{
  "3507862705384986122": "Nous avons des difficultés à vérifier votre compte. Veuillez réessayer la procédure de vérification. Si le problème persiste, veuillez nous contacter :",
  "1856199920316848480": "APPELER AAA",
  "194505828462863481": "APPELER",
  "4623814453348075508": "Veuillez saisir vos coordonnées pour commencer à bénéficier de notre service routier 24 h/24.",
  "9154643805570930321": "Veuillez saisir vos coordonnées AAA pour commencer à bénéficier de notre service routier 24 h/24.",
  "9084622949113164479": "reCAPTCHA par Google.",
  "5606023232758328379": " Confidentialité",
  "8826454553473999816": " et ",
  "2544569632476723854": "Conditions",
  "4304930410474432433": "<p>Nous sommes désolés. Vos identifiants de connexion ne correspondent pas à votre profil d'adhésion. Veuillez réessayer en saisissant :</p>\n<ul>\n <li><strong>PRÉNOM</strong> et <strong>NOM DE FAMILLE UNIQUEMENT</strong> <u>associés à votre adhésion AAA</u> : essayez différentes variantes, n'utilisez pas de traits d'union ni de deuxième prénom.</li>\n <li><strong>CODE POSTAL</strong> <u>associé à votre adhésion AAA</u> : utilisez le code postal de votre domicile. Si vous avez déménagé sans mettre à jour votre adresse auprès d'AAA, utilisez le code postal de votre domicile au moment de votre inscription.</li>\n</ul>\n",
  "1127413822733185182": "<p>Nous sommes désolés. Une erreur s'est produite lors de la vérification de vos informations. Veuillez réessayer.</p>",
  "653180531499256178": "<p>Il semble que nous ayons de la difficulté à vérifier les détails de vos informations.</p>",
  "4440524734440153673": "Si le problème persiste :",
  "638773896288575844": "Réessayez ou utilisez votre",
  "2768499270692105706": "Nom et prénom",
  "7775745687103185988": "Numéro de membre AAA",
  "7621075777303042085": "Numéro d’identification du véhicule (VIN)",
  "376003020172409710": "Plaque d’immatriculation et province",
  "9143659343338723414": "<p>Désolé, nous n'arrivons pas à vérifier votre adhésion AAA. Assurez-vous de saisir les <strong>numéros figurant sur votre carte et le code postal de votre domicile</strong>.</p>",
  "4673429546766018466": "<p>Il semble que nous ayons de la difficulté à vérifier votre numéro de membre AAA. Veuillez réessayer en utilisant les données du <strong>détenteur principal du compte</strong> pour le prénom, le nom de famille et le code postal du domicile.</p>",
  "408351360849277769": "<p>Il semble que nous ayons de la difficulté à vérifier votre nom et le code postal de votre domicile. Veuillez réessayer en utilisant votre <strong>numéro de membre AAA et le code postal de votre domicile</strong>.</p>",
  "4077858204299097550": "<p>Il semble que nous ayons de la difficulté à vérifier votre numéro de membre AAA. Assurez-vous de saisir le <strong>numéro de membre AAA figurant sur votre carte et le code postal de votre domicile</strong>.</p>",
  "173919868162035443": "<p>Il semble que nous ayons de la difficulté à vérifier votre plaque d'immatriculation et le kilométrage de votre véhicule. Veuillez réessayer en utilisant votre <strong>numéro d'identification du véhicule (NIV)</strong>.</p>",
  "8410601855345717390": "<p>Il semble que nous ayons de la difficulté à vérifier votre numéro d'identification du véhicule (NIV) et le kilométrage de votre véhicule. Veuillez réessayer ou utiliser votre <strong>plaque d'immatriculation</strong>.</p>",
  "6503781526479593589": "<p>Il semble que nous ayons de la difficulté à vérifier votre numéro d'identification du véhicule (NIV) et le kilométrage de votre véhicule. Veuillez réessayer en utilisant votre <strong>plaque d'immatriculation</strong>.</p>",
  "3687718752514734766": "<p>Il semble que nous ayons de la difficulté à vérifier votre plaque d'immatriculation et le kilométrage de votre véhicule. Veuillez réessayer ou utiliser votre <strong>numéro d'identification du véhicule (NIV)</strong>.</p>",
  "8397413982791871108": "Ou essayez d’utiliser votre",
  "8322393042243664713": "Impossible de vous connecter?",
  "6465999946621561944": "Vous ne disposez pas de votre numéro de membre AAA?",
  "4405754258064036451": "Nom et code postal du domicile",
  "5674593252524280885": "Appeler AAA",
  "1751565470889985786": "Appeler ici",
  "6028371114637047813": "Prénom",
  "6134315372404901571": " Le prénom est obligatoire. ",
  "4407559560004943843": "Nom de famille",
  "1017055857840819009": " Le nom de famille est obligatoire. ",
  "7173138156467248419": "Numéro de membre",
  "3285701240013573656": " Le numéro de membre est requis. ",
  "2792524269091946065": "Le numéro de membre doit comporter exactement 16 caractères.",
  "7708270344948043036": "{$INTERPOLATION}",
  "2623524733987339825": " Mémoriser mes informations ",
  "6041429819614882001": " Vous devez confirmer que vous n’êtes pas un robot. ",
  "6249484391846924804": " Confirmer ",
  "4451444712968571415": " Utilisez Le Numéro De Membre Pour Vous Connexion ",
  "2748277520068025484": " Utiliser Le Nom de Membre Pour Vous Connexion ",
  "1450918976331690321": "{$START_TAG_DRR_ICON}{$CLOSE_TAG_DRR_ICON} Se connecter avec la clé d’accès",
  "8144045218421106912": " Numéro de membre oublié ",
  "6049009368199223553": " À propos des clés d’accès ",
  "9027103269333492711": " Vous n’êtes pas membre? ",
  "6427877909211175463": " En sélectionnant Confirmer, vous acceptez ",
  "2749579379831074767": " les Conditions générales ",
  "4721007402656921350": " la Politique de confidentialité ",
  "9027333455101357051": "Impossible de vous connecter avec la clé d’accès. Veuillez réessayer ou utiliser une autre méthode de connexion.",
  "5890833044137447416": "Bienvenue!",
  "7510956113206631321": "Veuillez saisir ou confirmer le compteur kilométrique de votre véhicule ci-dessous pour commencer.",
  "8873434125903739325": "Veuillez saisir vos coordonnées ci-dessous pour commencer votre demande routière.",
  "4848086305568393449": "Veuillez saisir vos coordonnées de membre AAA pour commencer votre demande routière.",
  "3380552851557735887": "Veuillez sélectionner votre véhicule:",
  "734934965373819800": "Retour",
  "5060104992873903873": "Ajustez votre position",
  "5055369762621295136": "Aidez-nous à vous trouver",
  "6645327200464414799": "Glissez la carte vers l'emplacement de la panne ou saisissez l'adresse complète",
  "5171795527469989462": "Définissez votre emplacement",
  "2399650899606844980": "Faites glisser la carte pour déplacer l'épingle",
  "6702335294193404814": "rechercher un emplacement",
  "8349266787196318325": "confirmer l'emplacement",
  "2953235471192943631": " Confirmer la position ",
  "8520799611540090761": "Localisation De La Panne",
  "8996348957032272077": "Définir le lieu de la panne",
  "4021860812366269907": "Détails de l'emplacement",
  "7045123878111147511": "Obligatoire",
  "4761046835485571527": "Suivant {$START_TAG_AAA_ICON}{$CLOSE_TAG_AAA_ICON}",
  "1978572838634849210": "À la maison / Dans l’allée devant la maison",
  "1527014848829515039": "Dans un garage",
  "7572396993828932605": "Dans un parc de stationnement",
  "3257793298409521451": "Sur la route / la rue (Non-autoroute)",
  "6028236001700935513": "Sur une autoroute",
  "5114336751058438409": "Sortie d'autoroute",
  "8964882360012558063": "Saisir mon adresse",
  "4580988005648117665": "Rechercher",
  "7326852181282879609": "atelier suggéré",
  "8162787379579842000": "Recherche...",
  "1865518523086948674": "Désolé, les suggestions n'ont pas pu être chargées.",
  "2504058319323712311": "Utiliser la position actuelle",
  "840692109692540367": "Connexion",
  "7190243911747321024": "Revoir et soumettre",
  "8275450047090056721": "Suivi du service",
  "2750098008700422494": "Nous sommes désolés!",
  "7860418101283165917": "Fermé",
  "2226285948756237505": "jusqu’à l’arrivée",
  "6252696371173672888": "Devis de batterie",
  "4568701148410647318": "Devis de batterie AAA",
  "6233830031953140003": "Obtenir un devis",
  "3717501133734628767": "Pas de devis de batterie",
  "5447301746786979417": "Aucun devis disponible pour votre véhicule",
  "7819314041543176992": "Fermer",
  "3746101660448577866": "*Le remplacement de batterie peut ne pas être offert dans toutes les régions ni en tout temps.",
  "9132792097614191352": "Votre fournisseur de services est en route vers votre position.",
  "1746716113334252780": "Veuillez prévoir de rencontrer votre prestataire de services à l'endroit de la panne de votre véhicule.",
  "3989945387109482756": "Remorquage",
  "238497882963423948": "Détendez-vous pendant votre service de remorquage. Nous apprécions votre patience et vous remercions pour nous avoir choisi.",
  "6806508986920369710": "Nous sommes arrivés.",
  "166272444513464025": "Veuillez rencontrer votre prestataire de services à l'endroit de la panne de votre véhicule.",
  "9081883568571545398": "Votre demande a bien été reçue.",
  "3580891849269089480": "Nous vous informerons lorsque votre demande aura été assignée à un fournisseur de services.",
  "8084042636504252965": "Demande reçue",
  "7575520996332003540": "En route",
  "7596621968644952499": "Arrivé",
  "6170082236603228916": "Demande",
  "4556958906261851242": "Veuillez rester dans le véhicule lorsque l’assistance arrive.",
  "2526863831408005445": "Le membre AAA doit être présent dans le véhicule lorsque l’assistance arrive.<br/> Veuillez présenter une pièce d’identité avec photo.",
  "744599921555228591": "Nous sommes en route!",
  "4600565296787515345": "DÉPANNAGE",
  "8586969514214450775": "AAA ASSIST",
  "6490688569532630280": "Envoyer",
  "4426738042466538780": "Réflexion en cours",
  "4995265551641962648": "Informations sur les frais de carburant",
  "2742052866893113706": "Nous vous aiderons à vous rendre à la station-service la plus proche. Des frais de carburant peuvent s'appliquer pour ce service.",
  "2387539242412230109": "Nous sommes désolés.",
  "7217500509286769479": "Impossible de charger vos options de service. Veuillez réessayer.",
  "7934833136974560675": "Réessayer",
  "8725303542875623953": "Sélection Des Problèmes",
  "5063295649720964221": "Comment pouvons-nous vous aider?",
  "1379487740165792642": "Que s’est-il passé?",
  "3837070145043256486": "Démarrer une demande",
  "7397643214924929036": "Ce type de problème n'est pas disponible pour le moment.",
  "6614098000768940685": "Accident",
  "3714156896650215643": "S’il s’agit d’une urgence, veuillez appeler les services de secours (911 aux États-Unis). Si ce n’est pas le cas, un(e) technicien(ne) spécialisé(e) peut vous aider à transporter votre véhicule jusqu’à l’atelier de réparation automobile agréé le plus proche.",
  "4127837180659287294": "Test, Ou Remplacement De La Batterie",
  "2686615675222520734": "Batterie",
  "7929229449092125122": "Démarrage avec pinces",
  "1532212788231907236": "Nous pouvons tester votre batterie et la faire redémarrer à l’aide d’une batterie d’appoint, ou encore la remplacer par une nouvelle sur place. Veuillez noter que le remplacement de la batterie peut ne pas être disponible dans toutes les régions.",
  "1666079073089901973": "Nous pouvons tenter de faire redémarrer votre batterie ou de remorquer votre véhicule jusqu’à un centre de réparation.",
  "3473642902390597644": "Vous avez un problème avec la batterie de votre véhicule électrique? Nous évaluerons la situation et vous aiderons à rejoindre une station de recharge ou un centre de service.",
  "112279859555935914": "Des voyants lumineux ou un avertissement de recharge sur le tableau de bord de votre VE?",
  "9218270785295228352": "Oui, un avertissement de batterie faible s’affiche.",
  "5862864750739934991": "Non, mais des messages d'avertissement s'affichent dans le système.",
  "4675172324179157330": "Aucune alimentation ou réponse.",
  "9100517096724696709": "Besoin D’un Remorquage",
  "6787270058122459315": "Un(e) technicien(ne) spécialisé(e) peut vous aider à transporter votre véhicule jusqu’à l’atelier de réparation automobile agréé le plus proche.",
  "4020440838370105900": "Que se passe-t-il?",
  "1217079084843137811": "Ma batterie est à plat ou ne tient plus la charge",
  "8490558953502047785": "J'ai un pneu crevé et aucune roue de secours utilisable",
  "8272847685065462015": "Mon moteur a surchauffé ou s'est arrêté en roulant",
  "4103114379493249182": "Ma transmission ne passe pas les vitesses ou ne s'enclenche pas",
  "7764137279783948792": "Quelque chose d'autre ne va pas",
  "3099078401930296910": "Dites-nous en plus pour mieux vous aider",
  "5531315854465985018": "Pneu plat",
  "4301139003507179843": "En fonction des dommages subis par votre pneu, nous installerons votre roue de secours, regonflerons votre pneu ou remorquerons votre véhicule.",
  "938186089755102554": "Vous n’avez pas de pneu de rechange? Nous veillerons à ce que vous et votre véhicule soyez conduits en toute sécurité vers un centre de réparation ou de remplacement de pneus à proximité.",
  "112300762970095499": "Avez-vous des pneus de rechange pour chaque pneu plat?",
  "2807800733729323332": "Oui",
  "3542042671420335679": "Non",
  "6491627750429341127": "La Voiture Ne Démarre Pas",
  "3910361768174107122": "Votre voiture ne démarre pas et vous avez du mal à identifier le problème? Nous pouvons vous aider.",
  "3136898952316922211": "Le véhicule s’est arrêté en conduisant",
  "1828310215816344520": "Le véhicule ne réagit pas quand j’essaie de le démarrer - aucune activité au tableau de bord, aucun son.",
  "6509564028145231914": "J’entends un cliquetis quand j’essaie de démarrer la voiture.",
  "5576713558385508136": "Ma voiture tourne, mais ne démarre pas quand j’essaie de la démarrer.",
  "1345178385174181530": "Problème de batterie",
  "5386089199310835439": "Que se passe-t-il avec votre clé ou votre télécommande?",
  "2590844870369718742": "Véhicule verrouillé",
  "2176659033176029418": "Clé",
  "7267370775755984357": "Problèmes avec votre clé? Qu’elle soit perdue, brisée ou défectueuse, nous vous aiderons à reprendre la route.",
  "1073131304671493897": "Vous ne pouvez pas entrer dans votre véhicule? Nous enverrons quelqu’un pour vous aider à déverrouiller votre véhicule.",
  "4872380697349650717": "J’ai une situation hautement prioritaire",
  "2403761436161323684": "Un agent peut faire un suivi concernant votre situation.",
  "8671183489878457757": "Elle est enfermée dans le véhicule",
  "8464448176771967804": "Elle est brisée ou perdue",
  "7629299549022370794": "Elle ne démarre pas la voiture",
  "4270176564896969733": "Elle ne déverrouille pas la porte",
  "5536953270314943801": "Une personne ou un animal de compagnie est enfermé dans le véhicule",
  "423229861993154980": "Mes médicaments sont enfermés dans la voiture",
  "6912267234180689163": "Immobilisé",
  "395139254693543405": "Si votre véhicule est immobilisé, un(e) technicien(ne) vous aidera à reprendre la route.",
  "592942285591466618": "Nous sommes désolés d’apprendre que votre véhicule est immobilisé.",
  "2391317718429478610": "Votre véhicule devra-t-il être remorqué une fois qu’il aura été dégagé et remis sur la route?",
  "2040699163686699779": "Oui, mon véhicule devra être remorqué",
  "8468266698341875566": "Non, je n’ai pas besoin d’être remorqué(e)",
  "1083892150413432214": "Carburant/recharge électrique",
  "8271708390471469792": "Panne d’essence",
  "4347353823087945408": "Batterie déchargée",
  "5994746836305612236": "Vous avez besoin d’une recharge ou de carburant? Nous vous aiderons à vous rendre à la station-service la plus proche. La livraison de carburant diesel et les capacités de recharge sont disponibles à certains endroits.",
  "284255185161526674": "Votre batterie est déchargée? Notre équipe peut vous fournir une recharge ou remorquer votre véhicule jusqu’à la borne de recharge la plus proche, selon votre véhicule et les services disponibles dans votre région.",
  "208371421297503600": "Vous êtes à court d’essence? Nous vous livrerons du carburant ou remorquerons votre véhicule jusqu’à la station-service la plus proche pour que vous puissiez reprendre la route.",
  "6725665300768973808": "Vous êtes à court de diesel? Nous vous livrerons du carburant ou remorquerons votre véhicule jusqu’à la station-service la plus proche. La livraison de diesel peut être limitée dans certaines régions.",
  "1131278238586395824": "Veuillez sélectionner le type de carburant de votre véhicule.",
  "2274094072954341769": "Des frais supplémentaires peuvent s’appliquer en fonction du niveau d’adhésion.",
  "6639719078865772828": "Essence",
  "5294828297924157817": "Diesel",
  "7683384147050467124": "Véhicule électrique",
  "3716416002572111809": "Hydrogène/carburant alternatif",
  "5726454104363206493": "Alerte",
  "381426186146688465": "Pour poursuivre votre demande d’assistance routière, veuillez nous contacter ici :",
  "6319846836201438088": "Nous enverrons un service de batterie plutôt qu’un remorquage",
  "2116258634049106009": "Un(e) technicien(ne) testera votre batterie et votre système de charge.\n\nSi votre batterie est admissible au remplacement et que le service est offert, une nouvelle batterie pourrait être installée sur place.\n\nDes options de service supplémentaires pourraient être nécessaires selon l’évaluation du technicien.",
  "1220581101415477786": "Un(e) technicien(ne) évaluera votre batterie et tentera de redémarrer votre véhicule.\n\nSi le véhicule ne peut pas être démarré à l’aide de câbles, des options de service supplémentaires pourraient être nécessaires.",
  "8720977247725652816": "OK",
  "4817224180479830366": "Remplacement de batterie offert de {$PH} à {$PH_1}",
  "8030469785630718891": "Que se passe-t-il avec votre véhicule?",
  "8021063924309651332": "Dites-nous en plus sur le problème",
  "7919802320394920933": "TROUVONS CE QUI SE PASSE",
  "6294584129851319066": "Pour vous envoyer le bon camion du premier coup.",
  "6033469492202356107": "{$PH}, sélectionné",
  "6961397537815994802": "Nom du lieu",
  "8118425118386970064": "position GPS de l'utilisateur",
  "5019415900627253696": "épingle de localisation de l'utilisateur",
  "520216862429232810": "localiser l'utilisateur désactivé",
  "7759322752374112937": "Nous n'avons pas la permission d'utiliser votre localisation.",
  "4302275947494969248": "localiser l'utilisateur",
  "5914197729137852352": "agrandir",
  "2712619242453112454": "rétrécir",
  "4949889994019151135": "Ajuster La Position",
  "749435979294434408": "Rechercher dans cette zone",
  "8868423544621246196": "Ajuster l’épingle",
  "7469788397782054772": "Utiliser la position actuelle",
  "3253942101340114349": "Débloquer les avantages des membres et économiser",
  "1851052365566269794": "Jusqu'à 75$ de rabais sur la main-d'œuvre dans les installations approuvées par AAA.",
  "7661734687633394672": "Impossible de charger la carte.",
  "2372962615374041806": "réessayer de charger la carte",
  "5558369032942896106": "Appuyer pour réessayer",
  "5784148293777218417": "Chargement de la carte...",
  "4336812953219770811": " Remorquage à cet endroit ",
  "9051743466865402679": "logo AAA",
  "2315124459340038479": "Jusqu'à 75$ de rabais sur la main-d'œuvre",
  "187187500641108332": "{$INTERPOLATION}",
  "6126653859421382230": "Économies supplémentaires",
  "5088227879097923599": "ou Informations Fournies",
  "7426652496974317087": "Installation AAA",
  "3507975269329421784": "Approuvé AAA",
  "6481304460259131456": "CC rapide (DC Fast)",
  "1133429843474832091": "64 kilomètres d’autonomie pour 10 minutes de charge.",
  "9137973907103012820": "CA niveau 2 (AC Level 2)",
  "2033980371929070403": "En général, l’autonomie est d’environ 42 kilomètres par heure de charge.",
  "7222466127893410268": "CA niveau 1 (AC Level 2)",
  "7398398441416372596": "7 kilomètres d’autonomie par heure de charge, soit environ 22 heures pour une charge complète.",
  "8780046504816913168": "niveau de charge de la station",
  "1184558138767114183": "Ports EVSE",
  "3502982390707577330": "Ultra-rapide",
  "4440784179849538382": "Rapide",
  "5982496808088686844": "Moyen",
  "6080928629553303128": "Lent",
  "5185828311001602866": "Bornes de recharge",
  "5807244259479135620": "Notes sur les stations",
  "1827769659765031479": "Dernière mise à jour le {$START_TAG_STRONG}{$INTERPOLATION}{$CLOSE_TAG_STRONG}.",
  "4738544208382295311": "*Les détails et la disponibilité des ports pour borne de recharge pour VE sont susceptibles d’être modifiés.",
  "2419459929780942088": "Trouvons votre véhicule et votre position",
  "4540513583141016694": "Veuillez cliquer sur Autoriser lorsque le navigateur vous demande votre position actuelle.",
  "4107594969119943724": "Lieu du service",
  "3630564783213610949": "C’est le moyen le plus rapide d’accéder à votre position précise.",
  "5283964866465243726": "Veuillez utiliser votre adresse domicile ou saisir l’emplacement de votre panne.",
  "2668733150597455494": "Veuillez saisir l’emplacement de votre panne.",
  "7501294018510225443": "Trouver Ma Position",
  "3330279138270994973": "Utiliser mon adresse domicile",
  "6157723643771310203": "{$PH} entre les sorties {$PH_1} et {$PH_2}",
  "3981024025956691731": "{$PH} près de la sortie {$PH_1}",
  "6945807479901116465": "Je voyage avec un animal d’assistance",
  "8501473605570816670": "J’utilise un fauteuil roulant",
  "7722780722933930930": "J’ai une déficience visuelle",
  "3029169435027075291": "J’ai une déficience auditive",
  "1458126921436666295": "assets/drrweb-lib/images/fr/prompt-ios-service-location.png",
  "4506457520434156753": "assets/drrweb-lib/images/fr/prompt-chrome-windows-service-location.png",
  "8199801917286894103": "assets/drrweb-lib/images/fr/prompt-android-chrome-service-location.png",
  "8054771849619467014": "assets/drrweb-lib/images/fr/prompt-default-service-location.png",
  "1880639245768521590": "assets/drrweb-lib/images/fr/prompt-ios-service-location_rap.png",
  "470179781733224614": "assets/drrweb-lib/images/fr/prompt-chrome-windows-service-location_rap.png",
  "5417158386549523985": "assets/drrweb-lib/images/fr/prompt-android-chrome-service-location_rap.png",
  "734691974514323473": "épingle de localisation de panne",
  "2998515033796523032": "épingle de localisation de remorquage",
  "1685394033947973419": "épingle de localisation de voiture",
  "783289646359960934": "épingle d'installation AAA",
  "1508301018702466424": "épingle d'installation approuvée AAA",
  "4185783213014835176": "épingle de station EV",
  "5008865478775109392": "épingle de destination personnalisée",
  "2327312841241610698": "Combien de personnes doivent être transportées dans la dépanneuse?",
  "7127748442885437513": "La sécurité est notre priorité absolue. Nos véhicules de service ne peuvent accueillir que 2 passagers au maximum.",
  "8966552286310112745": "Zéro",
  "6983516129072435613": "Un",
  "3594109821899435342": "Deux",
  "579574604287234278": "Trois ou plus",
  "3767698756435505409": " Sélectionner ",
  "8293925737093594699": "Immédiatement disponible",
  "5385748884885581412": "Disponible Maintenant",
  "2152960452087805667": "Filtre:",
  "2893872988800957667": "Afficher les installations ouvertes",
  "7593555694782789615": "Ouvert",
  "4825929943644490784": "Afficher toutes les installations",
  "1616102757855967475": "Toutes",
  "1218302359178184742": "Trier par:",
  "3834095095299577159": "Filtre de distance",
  "1318378369686604409": "Trier par distance",
  "1779552786277618671": "Distance",
  "4229248268019362542": "Filtre de notation",
  "872726928974144719": "Trier par notation",
  "3706222784708785028": "Notation",
  "2476371896418380506": "Il n'y a aucune installation disponible dans votre région. Veuillez entrer une adresse personnalisée où vous souhaitez faire remorquer votre véhicule.",
  "6962699013778688473": "Continuer",
  "3350597898571280062": "* environ {$PH} miles au-delà de la limite de votre forfait",
  "3147697078524954695": "Le lieu de remorquage que vous avez sélectionné se trouve à plus de {$PH} milles. Veuillez vérifier votre destination de remorquage. Si l’adresse est exacte et que vous souhaitez poursuivre avec cette destination, appelez-nous.",
  "7117678034952001806": "Le lieu de remorquage que vous avez saisi est situé à plus de {$PH} milles. Voulez-vous continuer?",
  "1654520694751781139": "Nous avons reçu votre paiement, mais l’activation de votre adhésion prend plus de temps que prévu.",
  "1341731694437214881": "Pour toute assistance supplémentaire, veuillez appeler AAA",
  "6818973470543082695": "Nous continuerons également de vérifier automatiquement pendant que cet écran est ouvert.",
  "8970683817306462247": "Nous activons votre adhésion",
  "9008789757598843790": "Activation en cours…",
  "4075464256749670957": "Votre paiement a été reçu avec succès. L’activation de l’adhésion prend quelques minutes.",
  "5127370872020214133": "Votre paiement a été reçu. Nous continuons de travailler à l’activation de votre adhésion.",
  "8451263051582719390": "Votre adhésion AAA a expiré",
  "8145511312111660177": "Renouvelez maintenant pour demander une assistance routière.",
  "5237646879301056056": "Couverture disponible en quelques minutes",
  "2890192322152476399": "Vous protège dans n’importe quel véhicule (pas seulement le vôtre)",
  "5090376090543506834": "Assistance routière 24 h/24, 7 j/7 partout au pays",
  "7106302757096019164": "renouveler et obtenir de l’aide maintenant",
  "3164637444548569676": "Renouveler et obtenir de l’aide",
  "5793787693521708768": "Sécurisé. Confidentiel. Toujours protégé.",
  "426701527291002798": "Annuler la demande",
  "5202442660425731545": "Réservé pour une tranquillité d’esprit supplémentaire",
  "1640609344969975994": "À",
  "65596648518773631": "Statut de l'appel",
  "7562455884504549375": "Résumé de votre demande",
  "8536605442386598925": "*L’heure d’arrivée prévue n’est qu’une estimation. Une heure d’arrivée prévue en temps réel vous sera communiquée dès que votre fournisseur de services sera en route.",
  "1586840493150773164": "Clé d’accès créée avec succès!",
  "2241797766725932109": "Impossible de créer la clé d’accès.",
  "6695885093928433058": "Rendez-vous planifié",
  "3670741770315416004": "Demande en Cours",
  "471816275243265264": "Emplacement",
  "7132893068309658147": "Véhicule",
  "5833626790712999947": "Problème",
  "2786645340010357367": "Remorquer vers",
  "8725876728905260297": "Assistance spéciale",
  "1965356297860228129": "Passagers",
  "2296656948615950410": "Cliquez pour indiquer si vous voyagez avec un animal d’assistance, utilisez un fauteuil roulant, ou avez une déficience visuelle ou auditive.",
  "1220184337562705199": "Revoir et Soumettre",
  "2390801852034799296": "Tu y es presque.",
  "7768495123558312657": "Détails Supplémentaires",
  "4691558063344690327": "* Qui attendra avec le véhicule?",
  "4841246928267486909": "Le prénom est obligatoire.",
  "1761459821395698863": "Le nom de famille est obligatoire.",
  "2307899152676024835": "Le nom de famille doit comporter au moins 2 caractères.",
  "5980374903542048136": "* Comment le conducteur peut-il vous joindre?",
  "8194554728555410336": "Numéro de téléphone",
  "7242666881048019433": " Le numéro de téléphone est obligatoire. ",
  "7528160882558679290": " Numéro de téléphone à 10 chiffres. ",
  "4186571613071118113": "M’envoyer des mises à jour par SMS",
  "1807135899468939070": "Des frais de messages et de données standards peuvent s’appliquer. Vous pouvez également recevoir des sondages de suivi par SMS.",
  "407167630580620391": "Options de Planification",
  "5471200873438312944": "Détails de la demande",
  "2907103121504575461": "Pour bénéficier du service:",
  "4158861237816179273": "Soyez présent avec le véhicule à l'arrivée des secours.",
  "5885392364610839626": "Présentez votre permis de conduire et votre carte de membre.",
  "7351828748339218663": "Le véhicule doit être immatriculé.",
  "5203410453077950595": "Si ces conditions ne sont pas remplies, le service pourrait ne pas être fourni.",
  "6674369792289154406": "Pour bénéficier du service, veuillez vous assurer que:",
  "4708208019684315889": "Vous êtes avec le véhicule à l'arrivée des secours",
  "2577934289378208964": "Vous présentez votre permis de conduire",
  "8368187995205437382": "Le véhicule a une immatriculation valide",
  "4364826466877448830": "Soumettre la demande",
  "3502515833012687476": " Votre demande prend un peu plus de temps que prévu! Nous vous remercions de votre patience. ",
  "4070301057313245497": "Destination de remorquage précédente",
  "7877546010612799744": "Destination de remorquage suivante",
  "7011552147496839463": "Masquer les cartes",
  "7707573867079284235": "Afficher les cartes",
  "7353391633559525757": "Voir la liste",
  "7668320482416064562": "Installations de recharge",
  "5028777105388019087": "Détails",
  "3762979430784316447": "Remorquage vers l'installation",
  "5621871733375268792": "Recherche d’installations à proximité…",
  "4394425444565366157": "Cela peut prendre quelques secondes",
  "5212875263922018260": "Veuillez sélectionner une destination de remorquage",
  "5117814417431538560": "Installations Disponibles",
  "1778689203508413470": "Afficher Sur La Carte",
  "1581537317993347062": "Aucune installation à proximité",
  "6637503874356397315": "Entrer une adresse personnalisée",
  "3165693768265430259": "Lieu de remorquage",
  "6171321268156747297": "Capacité limitée dans les dépanneuses",
  "4732097627397727883": "Les dépanneuses n’ont que deux places de disponibles. Afin de transporter tous vos passagers en toute sécurité, veuillez trouver un autre moyen de transport.",
  "3042471551767868839": "Avis",
  "1149926629858366555": " Votre demande ne peut pas être créée/annulée pour le moment. Pour obtenir de l’aide, veuillez nous contacter ici : ",
  "714734299696371803": "ignorer ce message",
  "4128937884409277931": " Ignorer ",
  "8525213662266893834": "Nous contacter",
  "202442244688100878": "fermer",
  "5547981558491672240": " Fermer ",
  "1843612596643057114": " Couverture épuisée ",
  "89956979946656905": " Votre couverture est épuisée. Pour explorer vos options, veuillez appeler : ",
  "5342146806420323673": "Une erreur s’est produite.",
  "3619829665188684364": "Pour toute assistance supplémentaire, veuillez nous contacter ici :",
  "573014776611181853": " Autorisation impossible ",
  "4851841151431186708": " Nous avons des difficultés à autoriser le service routier avec votre adhésion. Veuillez réessayer. Si le problème persiste, veuillez nous contacter : ",
  "6997455656073982155": " Pour poursuivre votre demande d’assistance routière, veuillez nous contacter ici : ",
  "3460597674362212012": " Nous sommes désolés! ",
  "3597534558032156787": " Nous avons des difficultés à vérifier votre adhésion. Veuillez réessayer. Si le problème persiste, veuillez nous contacter : ",
  "2674407765127209694": " Nous avons des difficultés à vérifier votre numéro de référence. Veuillez réessayer. Si le problème persiste, veuillez nous contacter : ",
  "1967275184995311651": "Nous sommes désolés",
  "5047942184110371848": " Le système d’exploitation de votre appareil ne prend pas en charge cette fonctionnalité. Pour continuer, mettez à jour votre système d’exploitation à la dernière version ou contactez-nous pour obtenir de l’aide : ",
  "3145106811611964936": " Nous avons des difficultés à vérifier votre numéro d’abonné. Veuillez réessayer. Si le problème persiste, veuillez nous contacter : ",
  "2746225969289306647": "Votre demande ne peut être satisfaite pour le moment.",
  "3964046316066867815": "Mettre à jour mon emplacement",
  "3971100408152984961": " Suivant ",
  "4697489577451788862": "Appel annulé ",
  "3049349201532302920": " Votre appel a été annulé. Si vous avez besoin d’une assistance supplémentaire, veuillez appeler : ",
  "3445785675238664638": "Appel terminé ",
  "4394774848447555911": " Votre appel est terminé. Si vous avez besoin d’une assistance supplémentaire, veuillez appeler : ",
  "8145625183898098569": "Demande en cours",
  "7179250617627296125": "Nous ne sommes pas en mesure de répondre à cette demande, car il se peut que vous ayez déjà une demande de service active,",
  "7563348316522405611": "veuillez appeler AAA pour obtenir de l’aide.",
  "624925154094700659": "veuillez nous appeler pour obtenir de l’aide :",
  "6875129378498130947": "Charger la demande",
  "6061761806308938004": " Charger la demande ",
  "4228815428302028705": "Votre ID de membre",
  "8787812510068520833": " Nous sommes désolés d’apprendre que vous n’avez pas votre numéro de membre AAA. Pour rappel, votre numéro de membre se trouve au recto de votre carte de membre AAA. ",
  "5796746532161831712": "Pour poursuivre votre demande de service, veuillez appeler le numéro ci-dessous.",
  "2159130950882492111": "Annuler",
  "9178182467454450952": "Confirmer",
  "7875361674553895704": "redémarrage",
  "7970662669745283158": "{$PH} Demande routière?",
  "2569337048425166220": "Ne vous inquiétez pas, toutes les informations que vous avez saisies seront sauvegardées.",
  "3559861716234464695": "Si vous redémarrez, toutes les informations que vous avez saisies seront perdues.",
  "5556232190900941384": "Vous êtes sur le {$START_TAG_STRONG}{$INTERPOLATION}{$CLOSE_TAG_STRONG}, qui ne peut être desservi que par des fournisseurs autorisés.",
  "4883556295987649416": "Veuillez cliquer ci-dessous pour appeler le {$START_TAG_STRONG}{$INTERPOLATION}{$CLOSE_TAG_STRONG} pour un service routier d'urgence.",
  "4000395523613920402": " Mettre à jour ma localisation ",
  "5134046032924026802": " Le lieu que vous avez sélectionné est à plus de {$INTERPOLATION} milles de vos coordonnées GPS. {$START_BOLD_TEXT}Est-ce correct?{$CLOSE_BOLD_TEXT}",
  "3603720768157919481": " Non ",
  "6599544439234082262": " Oui, continuer ",
  "3624087939467349290": "Avis",
  "1373283122802403731": "Non disponible dans votre région",
  "1428411674072210734": "L'assistance routière n'est pas disponible dans votre région pour le moment.",
  "6096210050791665674": "Vous n’êtes pas membre?",
  "2338939239122506630": "Nous pouvons encore vous aider.",
  "1946294985129328189": " Appelez-nous et nous vous mettrons en relation avec un(e) représentant(e) du service clientèle. ",
  "6485080467526385593": "Si vous avez été victime d’un accident, veuillez suivre les lois et les lignes directrices de l’État ",
  "394133167965760742": "pour demander une aide d’urgence.",
  "5178599162303761880": " APPELEZ LE 9-1-1 ",
  "5651212469606235921": "Demande d’assistance routière annulée",
  "5630357643750336045": " Nous sommes désolés si vous rencontrez des difficultés. Si vous avez besoin d’une assistance supplémentaire, veuillez appeler : ",
  "927769103476181261": "{$INTERPOLATION} Veuillez nous contacter pour que nous puissions vous aider.",
  "8768553494169426221": "La destination de remorquage semble être la même que le lieu de votre panne. Veuillez mettre à jour la destination de remorquage pour continuer.",
  "6759205696902713848": "Avertissement",
  "3211375812239059616": "Votre session est sur le point d’expirer!",
  "1594967442652354065": "Cliquez sur le bouton « Continuer la session » pour rester connecté(e).",
  "6529234709124727228": "Continuer la session",
  "4914709593048205667": " Continuer la session ",
  "4216697563325477660": "* environ {$INTERPOLATION} miles au-delà de la limite de votre forfait",
  "8309867053765019374": "L’adresse de destination est incomplète. Veuillez sélectionner une destination contenant au moins un nom de rue.",
  "1812273367521629087": " Informations supplémentaires requises ",
  "2995600988434044148": " Le prénom est obligatoire ",
  "2330577642930707695": " Annuler ",
  "2234340424130179004": "Numéro de rue ",
  "4909632409145902244": " Le numéro de rue est obligatoire ",
  "5695082808871799804": " Aidez-nous à trouver votre compte ",
  "2098506548009623840": "Veuillez saisir le numéro de téléphone associé à votre adhésion AAA :",
  "2097047258816797651": "INDICE :",
  "3965497959922603703": "Numéro de téléphone du titulaire principal du compte",
  "4328252963732594198": " Le numéro de téléphone est obligatoire. ",
  "7608815404856420812": " Le numéro de téléphone doit comporter exactement 10 chiffres. ",
  "5207905874002096604": "Le numéro de téléphone saisi ne correspond à aucun des numéros ci-dessus.",
  "7834793667311493084": " Garantie limitée de remplacement gratuit de 3 ans",
  "7383286124047740036": " Moteur : ",
  "5580626612188557413": " N° de pièce : ",
  "2925999321421245631": " CCA : ",
  "1740519976235479440": " Prix réservé aux membres : ",
  "5882908235465956540": " Vos économies en tant que membre : ",
  "487840642825782696": " *Le prix n’inclut pas les taxes de vente/EPA et les éventuels frais de main-d’œuvre. La disponibilité des stocks varie; si votre batterie n’est pas disponible, un test de batterie et un redémarrage à l’aide d’une batterie d’appoint ou un remorquage seront fournis. ",
  "1660435965636215711": "Pourquoi annulez-vous?",
  "4998851725171607335": " Veuillez nous aider à comprendre pourquoi vous souhaitez annuler votre demande d’assistance routière : ",
  "8693603235657020323": "Autre",
  "5278917978974156212": "Dites-nous pourquoi vous annulez...",
  "554566638268240771": " Veuillez ajouter un commentaire. ",
  "8191160628682052797": "Veuillez soumettre la demande d’assistance routière lorsque vous êtes prêt(e).",
  "2433918188239435254": "Nous vous remercions de nous avoir informés que vous avez eu recours à un autre fournisseur de services.",
  "6634932823875452919": "Nous vous remercions de nous avoir informés que votre véhicule a démarré et que vous n’avez plus besoin d’assistance routière.",
  "5042135316044918443": "Une adhésion active à AAA pour bénéficier du service d’assistance routière.",
  "9130943841771661280": "Une pièce d’identité avec photo en cours de validité au moment du service.",
  "2795185191739439901": "Les membres doivent se trouver à bord du véhicule au moment du service.",
  "6101771822405833037": "Nous assistons actuellement des membres AAA dans votre région.",
  "4800017478718258125": "Nous vous remercions de nous avoir informés qu’un(e) ami(e) ou un membre de votre famille vous a aidé(e) et que vous n’avez plus besoin de l’assistance d’AAA.",
  "3978003244051742456": "Merci de nous avoir informés que l’emplacement fourni pour la panne ou le remorquage était incorrect. Veuillez mettre à jour l’adresse et soumettre de nouveau votre demande si vous avez encore besoin d’assistance.",
  "725801066718064552": "Veuillez contacter AAA si vous avez besoin d’une assistance supplémentaire.",
  "8336086995176361561": "Mon véhicule a démarré",
  "8301498400691107352": "Pas avec mon véhicule ou sans pièce d’identité avec photo",
  "4921174424767158794": "Heure d’arrivée prévue/temps d’attente trop long",
  "3790229158895884861": "Un(e) ami(e) ou un membre de la famille m’a aidé(e)",
  "70601770189571078": "Service demandé à un autre fournisseur",
  "4542685776525522536": "Adresse erronée pour l’emplacement de la panne ou du remorquage",
  "1228041941681869539": "Je soumettrai ma demande plus tard",
  "5570922785143068862": "Nous serons ici si vous avez besoin de nous",
  "4547976577033030523": "Merci de nous tenir informés",
  "1273563518651033849": "Vous avez pu reprendre la route",
  "3605654267658930496": "Le service d’assistance routière AAA exige",
  "6631370214417821009": "Nous nous excusons pour la longue attente",
  "1463264795502028813": "Merci de nous tenir informés",
  "2574924088459765443": "Emplacement incorrect fourni",
  "6514305188130738666": "Nous vous remercions pour vos commentaires.",
  "3170892836969933563": "Préférences d’installations",
  "199681881373518804": "Avantages pour les membres",
  "4636616640072565270": "Économies",
  "8257281017979049775": " Jusqu’à {$START_TAG_AAA_TEXT}{$INTERPOLATION}{$CLOSE_TAG_AAA_TEXT} de main-d’œuvre dans les installations approuvées par AAA. ",
  "8461842260159597706": "Afficher",
  "4461870650853986011": "Ouvert Maintenant",
  "7705146805699679308": "Basculer vers Ouvert Maintenant",
  "3163736126501632521": "Prêt à accepter votre véhicule",
  "5992079258862809181": "Basculer vers Disponible Maintenant",
  "7699622144571229146": "Trier par",
  "6184900616909551342": "Évaluation des membres",
  "4312517319627808728": "Réinitialiser les filtres",
  "6978234364807213493": " Réinitialiser les filtres ",
  "4252274043276232149": "Appliquer les filtres",
  "3764298087243734987": " Appliquer les filtres ",
  "8221191823278537940": "75$ de rabais",
  "3335125097066671488": " Choisissez votre nouvelle langue: ",
  "4640251381797093653": " Système d'unités: ",
  "1082186572052604070": " Aidez-nous à vous trouver! ",
  "920498844333598862": "Donnez-nous des informations supplémentaires pour aider le conducteur à vous trouver.",
  "1793340305918324038": "Bâtiment ou rue à proximité : ",
  "4317231584543100875": " N’hésitez pas à ajouter un commentaire pour nous aider à vous trouver. ",
  "6433934975299076647": " Création d’une clé d’accès ",
  "7960261666827623084": " Si vous éprouvez des difficultés à créer une clé d’accès, essayez ce qui suit : ",
  "3226515165280717048": "Conseils pour créer une clé d’accès",
  "4585655302901132242": " Assurez-vous que votre appareil et votre navigateur prennent en charge les clés d’accès. ",
  "8204277307134103557": " Activez le verrouillage de l’écran de votre appareil (Face ID, Touch ID, empreinte digitale ou NIP). ",
  "1742310145780775447": " Mettez à jour votre navigateur et votre système d’exploitation. ",
  "2530911237912691285": " Si vous utilisez une fenêtre de navigation privée, essayez une fenêtre de navigateur normale. ",
  "2480700450286234631": " Suivez les instructions pour créer et enregistrer votre clé d’accès. ",
  "5151302772594817091": " Si l’option n’apparaît toujours pas, essayez un autre navigateur ou appareil. ",
  "343835394852176599": "Création d’une clé d’accès",
  "1239986160529764202": "Créer une clé d’accès",
  "6233136260309825485": " Créer une clé d’accès ",
  "6232880258565681833": " Pendant que vous attendez, vous pouvez configurer une clé d’accès pour ouvrir une session plus rapidement, sans mot de passe, la prochaine fois. ",
  "3629102297901837941": "Méthodes d’ouverture de session offertes",
  "1528205876811012885": "Face ID",
  "6944174136827022440": "Touch ID",
  "1644631291332591230": "Code d’accès",
  "2585004117222105295": " Créer une clé d’accès ",
  "8381471742922310449": " Pas maintenant ",
  "2094590441447362024": "À propos des clés d’accès",
  "5288176706687121532": "Des problèmes pour créer une clé d’accès?",
  "7836958718246237142": " Se connecter avec une clé d’accès ",
  "1786179172967092395": "{$START_TAG_SPAN}Les clés d’accès{$CLOSE_TAG_SPAN} sont conçues pour remplacer vos mots de passe traditionnels et peuvent être utilisées pour accéder à AAA Digital Roadside Assistance. Il s’agit d’une authentification facultative qui offre une expérience de connexion sûre et sécurisée grâce au chiffrement de bout en bout. ",
  "1895659320322539850": "Avantages des clés d’accès",
  "6125393979162068859": " Connexion plus rapide et sans mot de passe ",
  "6921393565505052089": " Sécurité renforcée grâce à l’authentification de l’appareil ",
  "2286904483650741837": " Synchronisation sur tous vos appareils de confiance ",
  "3700327405617139488": " Configuration d’une clé d’accès ",
  "2408837570872877476": " Connectez-vous à l’aide de votre prénom et de votre nom ou de votre numéro de membre AAA. ",
  "6826884095497629723": " Complétez votre demande d’assistance routière. ",
  "2815732092125234624": " Si votre appareil prend en charge les clés d’accès, vous serez invité(e) à en créer une après avoir soumis votre demande d’assistance routière numérique. ",
  "4134229199185847776": " Suivez les instructions à l’écran pour terminer la configuration. ",
  "3977779423491488098": " La prochaine fois que vous vous connecterez à AAA Digital Roadside Assistance, vous serez prêt(e) à vous connecter en toute sécurité sans mot de passe. ",
  "5853440980923544185": " Des problèmes pour vous connecter ou créer une clé d’accès? ",
  "7096986431591826685": "Se connecter avec une clé d’accès",
  "7915635145286683183": "Utiliser une clé d’accès pour vous connecter",
  "3569641787255523569": " Utiliser une clé d’accès pour vous connecter ",
  "7061285914825382189": " Si vous éprouvez des difficultés à utiliser une clé d’accès, essayez ce qui suit : ",
  "1619866045452626924": "Conseils pour utiliser une clé d’accès pour vous connecter",
  "6104344328428105328": " Utilisez le même appareil que celui sur lequel votre clé d’accès a été créée. ",
  "1839199488887182672": " Si vous utilisez un autre appareil, connectez-vous à l’aide d’une autre méthode disponible. ",
  "6841371375885083076": " Assurez-vous que l’authentification biométrique de votre appareil (Face ID, Touch ID, empreinte digitale ou NIP) est activée et fonctionne correctement. ",
  "2234009211835487407": " Vous n’avez plus accès à votre appareil? ",
  "2939285354959258686": " Si vous n’avez plus accès à l’appareil sur lequel votre clé d’accès a été créée, connectez-vous à l’aide d’une autre méthode disponible et créez une nouvelle clé d’accès sur votre appareil actuel après avoir soumis votre demande d’assistance routière numérique. ",
  "1475642740902337582": "Voir les avis",
  "8895523169171160716": "Sélectionner cette installation",
  "9162819567693962814": "Veuillez nous contacter à {$START_LINK}{$INTERPOLATION_1}{$CLOSE_LINK} afin que nous puissions vous aider.",
  "1096523922580861220": "Remises réservées aux membres AAA",
  "129773953916702393": "Cette installation offre aux membres AAA :",
  "6497936021121348661": "Les membres AAA bénéficient d’une remise de 10 % sur la main-d’œuvre pour les réparations effectuées dans cette installation. La remise maximale sur la main-d’œuvre est de 75 $.",
  "8686926613390516729": "Voir ou masquer les commentaires de l’installation",
  "7215101881367554791": "Voir plus",
  "3517550046701184661": "Voir moins",
  "2096293725142689481": "Services de réparation",
  "8070396816726827304": "Heures",
  "1637807395996624480": " Le membre AAA doit être présent dans le véhicule lorsque l’assistance arrive. ",
  "6232767962101986120": " Veuillez vous préparer à présenter une pièce d’identité avec photo. ",
  "6108303594027259064": "Vous pensez avoir besoin d’une nouvelle batterie?",
  "8407027090855094486": "En tant que membre AAA, vous {$START_BOLD_TEXT}ÉCONOMISEZ{$CLOSE_BOLD_TEXT} sur tous les achats de batterie!",
  "4822875174643597985": "*Le remplacement de batterie peut ne pas être offert dans toutes les régions ni en tout temps.",
  "4550483070637072617": " OBTENIR UN DEVIS DE BATTERIE AAA ",
  "1081985883670154175": " Malheureusement, nous n’avons pas trouvé de devis de batterie pour votre véhicule. ",
  "7532012621192092169": " FERMER ",
  "6628195999288023750": "Sélectionnez toutes les options applicables afin que nous puissions offrir la meilleure assistance.",
  "2422796432434276307": "Animal d’assistance",
  "8502519270764282647": "Voyage avec un animal d’assistance",
  "5365957413422942691": "Fauteuil roulant",
  "3367838042296862793": "Utilise un appareil de mobilité",
  "3095443157864275679": "Déficience visuelle",
  "9183526258645897709": "Basse vision ou cécité",
  "1184769887075133184": "Déficience auditive",
  "8853351689294432570": "Malentendant(e) ou sourd(e)",
  "398580216793616453": "Numéro de membre invalide. Veuillez réessayer.",
  "2246225278009002637": " Création d’une clé d’accès... ",
  "3714782270026873188": " Vérification avec la clé d’accès ",
  "8973767917273413404": " Authentification avec la clé d’accès ",
  "1927565598938891479": "Kilométrage (En Kilomètres)",
  "6910896812795408604": "Kilométrage (En Milles)",
  "2339499141149709632": "Ajouter Un Véhicule",
  "7893027042015332014": " Quelle est la plaque d’immatriculation de votre véhicule? ",
  "1314196602451866850": "pas de véhicule trouvé",
  "2394888073923801575": "Pas de véhicule trouvé",
  "2467416691089785042": "La plaque d’immatriculation ou la province que vous avez saisie n’est pas correct. Veuillez réessayer ou ajouter votre véhicule en utilisant Marque/Modèle.",
  "810339320514898406": " Ajouter Un Véhicule ",
  "2375804625902745188": " Ajouter Un Véhicule Par Marque/Modèle ",
  "2374658616297168667": " Je ne connais pas ma plaque d’immatriculation ",
  "4525869092770982814": "Ajouter Un Véhicule Par Plaque D’immatriculation",
  "1645353594399026859": "Ajouter Un Véhicule Par Marque/Modèle",
  "8080814233715803011": "Couleur du Véhicule",
  "388441439738092480": "Sélectionnez la couleur de votre véhicule",
  "8778069024168313408": " Sélectionnez la couleur de votre véhicule ",
  "3881818169480672345": "autre",
  "7585826646011739428": "Modifier",
  "5038022816605629090": "Marque du Véhicule",
  "5530596553958425101": "Sélectionnez le modèle de votre véhicule",
  "5930101473609793295": "Sélectionnez la marque de votre véhicule",
  "8573148273930915356": "Marques Populaires",
  "1711723330428686508": "Modèle de Véhicule",
  "4877541786961592871": " Sélectionnez le modèle de votre véhicule ",
  "8737634160504397001": "J’ai un véhicule à quatre roues motrices ou à traction intégrale :",
  "1143180333250868580": "J’ai un véhicule à roues arrière jumelées (4 pneus à l’arrière) :",
  "7312227291647643129": "Veuillez sélectionner un modèle.",
  "3472776637183381934": "Ceci est obligatoire. Veuillez sélectionner Oui ou Non.",
  "4783450617882080730": "Entrez le modèle de votre véhicule",
  "6820908718479259935": "Sélection du véhicule",
  "6531169844162626489": "Quel véhicule est concerné par la demande?",
  "729718385405804359": " Ajoutez un véhicule en cliquant sur le bouton ci-dessous ",
  "4366195030139372163": "Ajouter un véhicule",
  "3643061693604299445": " Neutre ",
  "3309177967835549878": " Couleur ",
  "2376622895856215212": "Autre Couleur",
  "2277948714128983283": " Veuillez sélectionner votre véhicule: ",
  "3735258877351129283": " Mon véhicule n'est pas listé ci-haut ",
  "3104908833501051654": "Détails Du Véhicule",
  "322698561656118648": " RENSEIGNEMENTS SUR LE VÉHICULE ",
  "4663044829079526277": " Confirmer Le Véhicule ",
  "245000125673083892": " Ce n'est pas mon véhicule ",
  "1464072562214937907": "Année",
  "1511766279515968094": "Marque",
  "1141886420788473147": "Modèle",
  "9011959596901584887": "Couleur",
  "1600602015083950162": "Sélectionner la marque du véhicule",
  "8419013471383350703": "Sélectionner un véhicule",
  "8230776842044911093": "Suppression du véhicule",
  "7469554111775846390": "Veuillez confirmer la suppression du véhicule :",
  "7022070615528435141": "Supprimer",
  "1369053091611033364": "Année du véhicule",
  "2501218570987929523": "Année du Véhicule",
  "4474074263097209509": " Sélectionnez l’année de votre véhicule ",
  "4055565142797463521": "argenté",
  "5358044029583463092": "blanc",
  "2390091576468691188": "noir",
  "903698715562631272": "bleu",
  "4750497417886366863": "rouge",
  "3052455234498663450": "bordeaux",
  "6489918809066415959": "gris",
  "3561083222684861262": "pourpre",
  "1593879950157831165": "brun",
  "463342854199748936": "doré",
  "6192244276175907743": "vert",
  "1850999561099918087": "jaune",
  "4955630191692571673": "orange",
  "4931988436168518415": "Demander une assistance maintenant",
  "4815628358304255769": "Désolé, aucun créneau horaire n’est disponible.",
  "7283311229665311962": "Veuillez essayer une autre date.",
  "4818764971362919096": "Choisir une heure",
  "7017917500632081165": "Les services peuvent être demandés jusqu’à trois jours à l’avance, et les plages de service sont des créneaux de deux heures.",
  "7162759804277992326": "Demander un service et aller",
  "4244383936205942663": "Planifier une assistance plus tard",
  "3293376965478600452": "Réserver pour plus de tranquillité",
  "3933901227138831501": "Modifier le planning",
  "3207050836358092212": "à",
  "6048892649018070225": "Aujourd'hui",
  "9129734193759025482": "Demain",
  "790046669946855510": "Plaque d’immatriculation",
  "7147656645758186590": "Plaque d’immatriculation requise.",
  "3846775516007566225": " Le kilométrage est obligatoire. ",
  "7671097566105516848": " Le kilométrage est trop long. ",
  "8540477892957058580": " Le kilométrage ne peut pas être inférieur à {$INTERPOLATION}. ",
  "5712324546519089702": "Code postal du domicile",
  "2240639906372943686": " Le code postal n’est pas valide. ",
  "1999486591901322407": " Le code postal est obligatoire. ",
  "2482107679054510701": "Sélectionnez l’État",
  "5911214550882917183": "État",
  "247788107015006101": "État requis.",
  "6883930691020393717": "Ouvre",
  "5961730753997685905": "Ferme",
  "4585513060399239894": "États-Unis (English)",
  "4677726785527621059": "EN",
  "3863208364160367374": "Canada (English)",
  "5203393227857890726": "Canada (Français)",
  "2219810385897343218": "FR",
  "2388828436796635945": "milles",
  "5380734885525984829": "mi",
  "4008226394730667091": "kilomètres",
  "6044256456943348938": "km",
  "7837264740889869517": "AAA",
  "6449433906928390518": "Pneu plat",
  "7768588440687754652": "Plusieurs pneus plats",
  "3260747694170614659": "Service d’assistance aux cyclistes",
  "4949163154570277605": "Autre problème de pneu",
  "3937483171289747438": "Surchauffe du moteur",
  "1182848575500495908": "La voiture ne démarre pas / Problème de batterie",
  "4393476988942899254": "Test ou remplacement de batterie",
  "806714067987240899": "Démarreur inactif - Assistance batterie (batterie AAA)",
  "887388902744869206": "Le membre demande une assistance batterie",
  "5915528902414335352": "Besoin d’un remorquage",
  "1783762556138691700": "Problème de démarreur connu",
  "3152273838150533542": "Problème d’alternateur connu",
  "8729670228441145182": "Autre problème de démarreur",
  "5320409527192031890": "La voiture ne démarre pas",
  "1121003247955159358": "Panne de carburant",
  "5106773987744819236": "Véhicule électrique (VE) en panne de batterie",
  "89567510748154107": "Mauvais carburant dans le véhicule",
  "7608866105677900135": "Batterie VE épuisée",
  "7718232202645290143": "Autre problème de démarreur/démarrage",
  "1607751549135472283": "Les vitesses ne s’enclenchent pas",
  "2635833232154216737": "Le frein de stationnement ne se desserre pas",
  "4902704560614484469": "Le capot ou la porte ne ferme pas/ne verrouille pas",
  "8651276109470896460": "Un composant sous le châssis traîne au sol",
  "3627302731165021591": "Fuites de fluides",
  "2411256270426279168": "Pare-brise endommagé",
  "4352351100111809871": "Problème d’alarme de voiture",
  "1764347429718613820": "Panne de transmission/d’embrayage",
  "300454884679414178": "Défaillance de l’essieu/l’arbre de transmission/la suspension",
  "3275110414994727760": "Panne du système de freinage",
  "8307876019330383117": "Autre problème d’immobilisation du véhicule (sans panne moteur)",
  "1422534409101194863": "Le moteur a calé en conduisant (ou fonctionne mal)",
  "6346197418191521032": "Le moteur a calé en conduisant (ou autre problème de fonctionnement du moteur)",
  "6199390654915059120": "Clé enfermée dans le coffre avec système de déverrouillage du coffre",
  "1134916509776830024": "Clé cassée dans la porte - Pas la clé de contact",
  "4816129840545463770": "Serrure de portière gelée",
  "5269606850167934629": "Autre problème de verrouillage",
  "701251608477934057": "Clé enfermée dans le coffre - Pas de système de déverrouillage",
  "6142348476301771589": "Clé du véhicule perdue/endommagée",
  "284656505395688931": "Clé « Club » perdue/endommagée",
  "3514211625272598553": "Clé cassée dans la portière - Clé de contact",
  "418615325007080430": "Clé cassée dans le commutateur d’allumage",
  "8129095023010033917": "Maison verrouillée",
  "1908434710229907061": "Incendie du véhicule",
  "7996328812789188583": "Remorquage pour commodité/préoccupation du membre",
  "7466069527670677597": "Assistance accident avec assurance",
  "1498787579904490729": "Assistance accident avec assurance - Deuxième remorquage",
  "621862718126105807": "Service léger - Réorienter en tant que remorquage",
  "4351481082957031931": "Autre remorquage requis",
  "9196553889100032955": "Véhicule verrouillé",
  "6085791871913838678": "Problème de batterie",
  "3322791211742541863": "Démarreur inactif - Assistance batterie",
  "1590050062584587387": "Assistance batterie",
  "1245793507890087845": "Remorquage pour commodité/préoccupation",
  "8890553633144307762": "Retour",
  "8074044239461230413": " Bienvenue, {$INTERPOLATION}! ",
  "2171108128625220759": "Type d'adhésion:",
  "5162055214272417357": "Appel ID",
  "939198311791613190": "Changer de langue",
  "4211737493693856650": "Vous avez une urgence?",
  "9009534756135128779": "Optimisé par RESPONSE",
  "2675561881742221955": "Utiliser le numéro d'identification du véhicule (VIN)",
  "3724691018613206036": "Utiliser la plaque d'immatriculation du véhicule",
  "3554560152057051008": "Nous personnalisons votre expérience…",
  "5239049161374840743": "Cela prend un peu plus de temps que prévu.",
  "6656565264392926597": "Merci de votre patience.",
  "3119946717514237807": "Votre outil de suivi du service est ouvert.",
  "1293315060547166486": "Balayez vers le haut sur la fenêtre de suivi ou touchez ci-dessous pour continuer à suivre votre technicien.",
  "8896053661242873097": "Continuer le suivi",
  "9047657667885056779": "Il semble que l’outil de suivi ait été fermé.",
  "2861641926550874295": "Touchez le bouton ci-dessous pour afficher votre outil de suivi du service.",
  "5587865907622609469": "Afficher l’outil de suivi du service",
  "3367606868529944362": "Appeler l’atelier",
  "994157966875519838": "avis",
  "6306441078838263413": "avis",
  "5697775455373856404": "https://www.aaa.com/privacy",
  "5681080907064940207": "Contenu de la Politique de confidentialité",
  "325297667007265879": "https://www.aaa.com/AAA/common/drrsmsterms/terms.html",
  "9136883653011874874": "Contenu des conditions générales",
  "3907277565443688400": "Il semble que nous ayons trouvé un problème.",
  "2898103473773345400": "Désolé, nous ne pouvons pas afficher notre suivi de service sur cette page.",
  "3827211250193888984": "Accédez au suivi des services",
  "196852750330820489": "Merci de compter parmi nos précieux membres AAA depuis",
  "6479044529603381727": "an",
  "7658073495909471632": "ans",
  "249946661530734742": "Merci de compter parmi nos précieux membres AAA!",
  "5221447871170578113": "Il semble que le concessionnaire choisi comme destination de remorquage dépasse les limites de remorquage habituelles.",
  "5407935879683390459": "Il semble que vous ayez choisi une destination de remorquage qui dépasse les limites de remorquage habituelles, mais un autre concessionnaire à proximité peut vous aider. Veuillez choisir parmi la liste de concessionnaires fournie afin que nous puissions vous aider rapidement.",
  "5830141447760502883": "Il semble que le site de recharge de VE sélectionné comme destination de remorquage dépasse les limites de remorquage habituelles.",
  "7488235253439066670": "Il semble que vous ayez choisi une destination de remorquage qui dépasse les limites de remorquage habituelles, mais un autre site de recharge de VE se trouve à proximité pour recharger votre véhicule. Veuillez choisir parmi la liste des sites de recharge de VE fournie afin que nous puissions vous aider rapidement.",
  "7372157508120043424": "En raison du volume élevé de demandes de service, les distances de remorquage sont actuellement limitées dans votre région. Veuillez communiquer avec nous afin que nous puissions vous aider.",
  "8313172200055338045": "Nous sommes désolés, nous ne pouvons pas remorquer vers cet emplacement pour le moment. Veuillez appeler pour obtenir de l'aide.",
  "8069219870516771588": "Service routier RESPONSE",
  "467028499850443965": "Assistance routière AAA",
  "3936734437579216958": "Changer la sélection de véhicule",
  "1894851373519807395": " VIN est requis. ",
  "5711449076030373396": "VIN n'est pas valide.",
  "4831448418319098988": "Le VIN doit comporter exactement 17 caractères.",
  "81381789816265977": "Veuillez appeler AAA pour obtenir de l’aide supplémentaire :",
  "5507648102804470429": "Veuillez réessayer ou communiquer avec le service à la clientèle pour obtenir de l’aide :",
  "6431558244296134403": "Une erreur s’est produite lors de la récupération de vos informations.",
  "2260468369477279302": "Une erreur s’est produite lors de la récupération de vos informations de membre.",
  "8244890085971995980": "Une erreur s’est produite lors de la suppression de ce véhicule."
}